module.exports = ".sameline-image {\n  float: left;\n  margin: 20px 20px 0 0; }\n\n.img-cross {\n  position: absolute;\n  margin: -22px 52px auto; }\n\n.hazard-preview-form {\n  height: 100%;\n  padding: 10px 32px 10px 0;\n  background: #FFF;\n  border: 1px solid #919191; }\n\n.height-100 {\n  height: 80%;\n  position: relative; }\n\n.button-disable {\n  opacity: .50;\n  pointer-events: none; }\n\n.hazard-description {\n  float: left;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fix-action-form/fix-action-form.component.scss
// module id = ./src/app/fix-action-form/fix-action-form.component.scss
// module chunks = main